/* * eleReady.js
 * A simple utility to execute a function when elements matching a selector are present in the DOM.
*/
(function (win) {
    "use strict";
    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;
    function ready(selector, fn) {
    // Store the selector and callback to be monitored
    listeners.push({
        selector: selector,
        fn: fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
        childList: true,
        subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
    }
    function check() {
    // Check the DOM for elements matching a stored selector
    for (
        var i = 0, len = listeners.length, listener, elements;
        i < len;
        i++
    ) {
        listener = listeners[i];
        // Query for elements matching the specified selector
        elements = doc.querySelectorAll(listener.selector);

        for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        // Make sure the callback isn't invoked with the
        // same element more than once
        if (!element.ready) {
            element.ready = "select";
            // Invoke the callback with the element
            listener.fn.call(element, element);
        }
        }
    }
    }
    win.eleReady = ready;
})(this);



function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}


/* START - Change rating star text */
waitUntil(
  () => {
    const inner = document.querySelector(".rating-wrapper .RatingBarWidget__inner");
    if (!inner) return false;
    return !!inner.querySelector(".R-TextBody");
  }
).then(() => {
  const ratingWrapper = document.querySelector(".rating-wrapper");
  const inner = ratingWrapper && ratingWrapper.querySelector(".RatingBarWidget__inner");
  if (!inner) return;

  const reviewText = inner.querySelector(".cssVar-reviewText:last-child");
  if (reviewText && !reviewText.textContent.includes("Reviews")) {
    reviewText.textContent = " Store Reviews";
  }

  const reviewDiv = inner.querySelector(".R-TextBody");
  const ratingBarWidget = ratingWrapper.querySelector(".RatingBarWidget");

  // Hide store review clarification note for now
  /*
  if (ratingBarWidget && !document.querySelector(".store-review-note")) {
    ratingBarWidget.insertAdjacentHTML(
      "beforeend",
      `
      <div class="store-review-note">
        <span class="info-icon">🛈</span>
        <div>
          <strong>These are store reviews, not product-specific.</strong><br>
          Ratings shown reflect overall iTokri shopping experience.
          Individual product reviews coming soon.
        </div>
      </div>
      `
    );
  }
  */

  if (reviewDiv) {
    reviewDiv.addEventListener("click", () =>
      scrollToSection(".R-ReviewsList-container")
    );
  }
});
/* END - Change rating star text */


/* START - Sticky quantity and add to cart button  */
waitUntil(
  () =>
    document.querySelector(".qty-container") &&
    document.querySelector(".ATC-container") &&
    document.querySelector(".qty-atc-subcontainer") &&
    document.querySelector(".CP-stock-status-wrapper")
).then(() => {
  
  const qtyContainer = document.querySelector(".qty-container");
  const addToCartContainer = document.querySelector(".ATC-container");
  const subContainer = document.querySelector(".qty-atc-subcontainer");
  const customTextContainer = document.querySelector(".qty-label-cont");

  const custom_qty_atc_Container = document.querySelector('.CP-atc-qty-container');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          custom_qty_atc_Container.classList.remove("sticky");
        } else {
          custom_qty_atc_Container.classList.add("sticky");
        }
      });
    },
    {
      root: null,
      threshold: 1,
    }
  );

  observer.observe(customTextContainer);
});

/* END - Sticky quantity and add to cart button  */


/* START - Hide social share text */
waitUntil(() => document.querySelector(".product__social-share")).then(
  async () => {
    const shareEl = document.querySelector(".product__social-share");
    if (shareEl && shareEl.parentElement.parentElement) {
      shareEl.parentElement.parentElement.style.display = "none";
    }
  }
);
/* END - Hide social share text */


/* START - USP POPUP */
waitUntil(() => document.querySelector(".list_box .item_container")).then(() => {
  const itemContainers = document.querySelectorAll(".list_box .item_container");

  itemContainers.forEach((item) => {
    item.addEventListener("click", () => {
      if (item.classList.contains("return_items_container")) {
        document.body.classList.add("CP-uspOpen");
        document.querySelector(".CP-returnpolicy-popup")?.classList.add("active");
      } else if (item.classList.contains("easypurchase_items_container")) {
        document.body.classList.add("CP-uspOpen");
        document.querySelector(".CP-deliver-popup")?.classList.add("active");
      }
    });
  });

  // Handle popup close
  document.querySelectorAll(".CP-popClose").forEach((closeBtn) => {
    closeBtn.addEventListener("click", () => {
      document.body.classList.remove("CP-uspOpen");
      document.querySelector(".CP-returnpolicy-popup")?.classList.remove("active");
      document.querySelector(".CP-deliver-popup")?.classList.remove("active");
    });
  });
  // Overlay click to close (only when clicking the overlay, not the inner popup)
  document.querySelectorAll(".CP-usp-overlay").forEach((overlay) => {
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document.body.classList.remove("CP-uspOpen");
        document.querySelector(".CP-returnpolicy-popup")?.classList.remove("active");
        document.querySelector(".CP-deliver-popup")?.classList.remove("active");
      }
    });
  });
});
/* END - USP POPUP */


/* START - PDP Review Images Slider */
/*
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const cards = track.querySelectorAll(".CP-carousel-card");

  const firstClone = cards[0].cloneNode(true);
  const lastClone = cards[cards.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, track.firstChild);

  let currentIndex = 1;
  const totalCards = cards.length + 2;

  const updateCarousel = (smooth = true) => {
    const cardWidth = cards[0].offsetWidth + 20;
    const containerWidth = track.parentElement.offsetWidth;
    const offset = (containerWidth - cardWidth) / 2;
    const translateX = -currentIndex * cardWidth + offset;

    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle(
        "active",
        i === (currentIndex - 1 + cards.length) % cards.length
      );
    });
  };

  // Add dot indicators
  cards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1;
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = cards.length;
      updateCarousel(false);
    } else if (currentIndex === totalCards - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // Touch swipe
  let startX = 0;
  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    if (endX - startX > 50) {
      currentIndex--;
      updateCarousel();
    } else if (startX - endX > 50) {
      currentIndex++;
      updateCarousel();
    }
  });

  updateCarousel(false);
});

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const originalCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  const cardWidth = originalCards[0].offsetWidth;
  const containerWidth = track.parentElement.offsetWidth;
  const offset = (containerWidth - cardWidth) / 2;

  // Clone first and last card for infinite loop effect
  const firstClone = originalCards[0].cloneNode(true);
  const lastClone = originalCards[originalCards.length - 1].cloneNode(true);
  //track.appendChild(firstClone);
  //track.insertBefore(lastClone, track.firstChild);

  // Recalculate card list (now includes clones)
  const allCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  let currentIndex = 1; // Start at the "real" first slide

  const updateCarousel = (smooth = true) => {
    const translateX = -currentIndex * cardWidth + offset;
    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    // Update dots
    const dotIndex = (currentIndex - 1 + originalCards.length) % originalCards.length;
    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle("active", i === dotIndex);
    });
  };

  // Dot creation
  originalCards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1;
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  // Handle looping transition reset
  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = originalCards.length;
      updateCarousel(false);
    } else if (currentIndex === allCards.length - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // Swipe handling
  let startX = 0;
  let isSwiping = false;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isSwiping = true;
  });

  track.addEventListener("touchmove", (e) => {
    if (!isSwiping) return;
    const currentX = e.touches[0].clientX;
    const delta = currentX - startX;
    const translateX = -currentIndex * cardWidth + offset + delta;

    track.style.transition = "none";
    track.style.transform = `translateX(${translateX}px)`;
  });

  track.addEventListener("touchend", (e) => {
    if (!isSwiping) return;
    isSwiping = false;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (diff > 50) {
      currentIndex--;
    } else if (diff < -50) {
      currentIndex++;
    }
    updateCarousel();
  });

  updateCarousel(false); // Initial position
});
*/

/*
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".CP-carousel-track");
  const dotsContainer = document.querySelector(".CP-carousel-dots");
  if (!track || !dotsContainer) return;

  const originalCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  const cardWidth = originalCards[0].offsetWidth;
  const containerWidth = track.parentElement.offsetWidth;
  const offset = (containerWidth - cardWidth) / 2;

  // ✅ Clone first and last card for infinite loop effect
  const firstClone = originalCards[0].cloneNode(true);
  const lastClone = originalCards[originalCards.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, track.firstChild);

  // ✅ Update allCards after cloning
  const allCards = Array.from(track.querySelectorAll(".CP-carousel-card"));
  let currentIndex = 1; // Start at first real card (after lastClone)

  const updateCarousel = (smooth = true) => {
    const translateX = -currentIndex * cardWidth + offset;
    track.style.transition = smooth ? "transform 0.4s ease" : "none";
    track.style.transform = `translateX(${translateX}px)`;

    // ✅ Adjust active dot
    const dotIndex = (currentIndex - 1 + originalCards.length) % originalCards.length;
    document.querySelectorAll(".CP-carousel-dot").forEach((dot, i) => {
      dot.classList.toggle("active", i === dotIndex);
    });
  };

  // ✅ Create Dots
  originalCards.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.className = "CP-carousel-dot" + (index === 0 ? " active" : "");
    dot.addEventListener("click", () => {
      currentIndex = index + 1; // +1 because of prepended lastClone
      updateCarousel();
    });
    dotsContainer.appendChild(dot);
  });

  // ✅ Handle infinite loop reset
  track.addEventListener("transitionend", () => {
    if (currentIndex === 0) {
      currentIndex = originalCards.length;
      updateCarousel(false);
    } else if (currentIndex === allCards.length - 1) {
      currentIndex = 1;
      updateCarousel(false);
    }
  });

  // ✅ Swipe logic
  let startX = 0;
  let isSwiping = false;

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isSwiping = true;
  });

  track.addEventListener("touchmove", (e) => {
    if (!isSwiping) return;
    const currentX = e.touches[0].clientX;
    const delta = currentX - startX;
    const translateX = -currentIndex * cardWidth + offset + delta;

    track.style.transition = "none";
    track.style.transform = `translateX(${translateX}px)`;
  });

  track.addEventListener("touchend", (e) => {
    if (!isSwiping) return;
    isSwiping = false;
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (diff > 50) {
      currentIndex--;
    } else if (diff < -50) {
      currentIndex++;
    }
    updateCarousel();
  });

  updateCarousel(false); // ✅ Initial position
});
*/

document.addEventListener("DOMContentLoaded", function () {
  const carouselSlider = new Swiper(".CP-carousel-container", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    pagination: {
      el: ".CP-carousel-dots",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
});

/* END - PDP Review Images Slider */


/* START - Click To Scroll */
const scrollToSection = (selector) => {
  const section = document.querySelector(selector);

  if (section) {
    if (section.classList.contains("return_policy")) {
      section.classList.add("open");
    } else if (section.classList.contains("productDetail")) {
      section.previousElementSibling.classList.add("open");
    }
    const offset = 170;
    const topPos =
      section.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: topPos,
      behavior: "smooth",
    });
  }
};

const mappings = [
  { trigger: ".CP-detail-box", target: ".productDetail" },
  { trigger: ".CP-review-box", target: ".R-ReviewsList-container" },
  { trigger: ".CP-product-box", target: "#similar-products" },
  // { trigger: ".CP-shipping-container", target: ".return_policy" },
  { trigger: ".CP-read-review", target: ".R-ReviewsList-container" },
];

mappings.forEach(({ trigger, target }) => {
  const el = document.querySelector(trigger);
  if (el) {
    el.addEventListener("click", () => scrollToSection(target));
  }
});
/* END - Click To Scroll */





/* START - Reel ka Feel */
waitUntil(
  () =>
    document.querySelector(".glow_card .care-info-sec-heading") &&
    document.querySelector(".glow_card .glow_video_cards_wrapper")
).then(() => {

  const glowCard = document.querySelector(".glow_card");

  eleReady(
    ".glow_card .glow_wrapper .glow_video_cards_wrapper",
    function (glowWrapper) {
      const navIconLeft = document.createElement("a");
      navIconLeft.className = "CP-video-prev";
      navIconLeft.innerHTML = "&#10094;";

      const navIconRight = document.createElement("a");
      navIconRight.className = "CP-video-next";
      navIconRight.innerHTML = "&#10095;";

      const parentWrapper = glowWrapper.parentElement;

      const oldPrev = parentWrapper.querySelector(".CP-video-prev");
      const oldNext = parentWrapper.querySelector(".CP-video-next");
      if (oldPrev) oldPrev.remove();
      if (oldNext) oldNext.remove();

      parentWrapper.appendChild(navIconLeft);
      parentWrapper.appendChild(navIconRight);

      const videoCards = glowWrapper.querySelectorAll(".glow_video_box");
      let cardWidth = 0;
      if (videoCards.length > 0) {  cardWidth = videoCards[0].offsetWidth;  }
      if (videoCards.length === 0) return;

      /*
      */
      const url = [
        "https://itokri.com/collections/partners-homepage",
        "https://itokri.com/pages/contact-us",
        "https://itokri.com/collections/latest-collections-on-ekdum-fresh",
        "https://itokri.com/collections/womens-kurtis-kurtas",
        "https://itokri.com/collections/crewel-embroidery-cushion-covers",
        "https://itokri.com/collections/partners-homepage",
        "https://itokri.com/pages/contact-us",
        "https://itokri.com/collections/latest-collections-on-ekdum-fresh",
        "https://itokri.com/collections/womens-kurtis-kurtas",
        "https://itokri.com/collections/crewel-embroidery-cushion-covers",
      ];


    
      videoCards.forEach((div, index) => {
        const targetUrl = url[index] || "#";

        div.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          window.open(targetUrl, "_blank");
        });
      });

      navIconLeft.addEventListener("click", () => {
        console.log("click left");
        glowWrapper.scrollBy({
          left: -cardWidth,
          behavior: "smooth",
        });
      });

      navIconRight.addEventListener("click", () => {
        console.log("click right");
        glowWrapper.scrollBy({
          left: cardWidth,
          behavior: "smooth",
        });
      });


// Function to show/hide arrows based on scroll position
function updateArrowVisibility() {
  const scrollLeft = Math.round(glowWrapper.scrollLeft);
  const maxScrollLeft = glowWrapper.scrollWidth - glowWrapper.clientWidth;

  // Hide left arrow if fully scrolled to left
  const twoCardWidth = cardWidth;
  if ( scrollLeft <= twoCardWidth ) {
    navIconLeft.style.display = "none";
  } else {
    navIconLeft.style.display = "block";
  }

  // Hide right arrow if fully scrolled to right
  if (scrollLeft >= Math.round(maxScrollLeft) - 2) {
    navIconRight.style.display = "none";
  } else {
    navIconRight.style.display = "block";
  }
}

// Initial check
updateArrowVisibility();

// Re-check on scroll and resize
glowWrapper.addEventListener("scroll", updateArrowVisibility);
      
  });
});
/* END - Reels and Reviews */







/*
waitUntil(() => document.querySelector(".product-info-block")).then(() => {
  if (document.body.classList.contains("CP-product-info-open")) return;

  const contactButton = document.querySelector(".CP-contact-button");

  contactButton.addEventListener("click", async () => {
    if (document.querySelector(".CP-product-info-overlay")) return;

    const overlay = document.createElement("div");
    overlay.className = "CP-product-info-overlay";

    const popupContent = document.createElement("div");
    popupContent.className = "CP-product-info-popup";

    const closeBtn = document.createElement("a");
    closeBtn.className = "CP-popup-close-btn";
    closeBtn.innerHTML = "&#10006;";
    popupContent.appendChild(closeBtn);

    const productInfoBlock = document
      .querySelector(".product-info-block")
      .cloneNode(true);
    popupContent.appendChild(productInfoBlock);

    overlay.appendChild(popupContent);
    document.body.appendChild(overlay);
    document.body.classList.add("CP-product-info-open");

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        document.body.classList.remove("CP-product-info-open");
        overlay.remove();
      }
    });

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      document.body.classList.remove("CP-product-info-open");
      overlay.remove();
    });
  });
});
*/


/* START - Saree PDP USP popups */
(function initSareeUspModals() {
  "use strict";

  var OPEN_SELECTOR = "[data-saree-usp-open]";
  var CLOSE_SELECTOR = "[data-saree-usp-close]";
  var MODAL_SELECTOR = "[data-saree-usp-modal]";
  var OPEN_STATE_CLASS = "is-open";
  var BODY_STATE_CLASS = "saree-pdp-usp-modal-open";

  var lastTrigger = null;

  function getOpenModal() {
    try {
      return document.querySelector(MODAL_SELECTOR + "." + OPEN_STATE_CLASS);
    } catch (error) {
      console.error("[SareeUspModal] Unable to read the open modal:", error);
      return null;
    }
  }

  function closeModal() {
    var openModal = getOpenModal();
    if (!openModal) return;

    openModal.classList.remove(OPEN_STATE_CLASS);
    openModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove(BODY_STATE_CLASS);

    if (lastTrigger && typeof lastTrigger.focus === "function") {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function openModal(trigger) {
    var modalId = trigger.getAttribute("data-saree-usp-open");
    if (!modalId) {
      console.error("[SareeUspModal] Trigger is missing a modal id.");
      return;
    }

    var modal = document.querySelector(
      '[data-saree-usp-modal="' + modalId + '"]'
    );
    if (!modal) {
      console.error("[SareeUspModal] No modal found for id:", modalId);
      return;
    }

    closeModal();

    modal.classList.add(OPEN_STATE_CLASS);
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add(BODY_STATE_CLASS);
    lastTrigger = trigger;

    var closeButton = modal.querySelector(CLOSE_SELECTOR);
    if (closeButton && typeof closeButton.focus === "function") {
      closeButton.focus();
    }
  }

  function handleDocumentClick(event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      if (target.closest(CLOSE_SELECTOR)) {
        event.preventDefault();
        closeModal();
        return;
      }

      var trigger = target.closest(OPEN_SELECTOR);
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
      }
    } catch (error) {
      console.error("[SareeUspModal] Click handling failed:", error);
    }
  }

  function handleDocumentKeydown(event) {
    if (event.key !== "Escape" && event.key !== "Esc") return;

    try {
      closeModal();
    } catch (error) {
      console.error("[SareeUspModal] Escape handling failed:", error);
    }
  }

  document.addEventListener("click", handleDocumentClick);
  document.addEventListener("keydown", handleDocumentKeydown);
})();
/* END - Saree PDP USP popups */

/* START - Saree PDP delivery estimate */
(function initSareeDeliveryEstimate() {
  "use strict";

  var ROOT_SELECTOR = "[data-saree-delivery]";
  var TEXT_SELECTOR = "[data-saree-delivery-text]";
  var READY_STATE_CLASS = "is-ready";
  var UNAVAILABLE_STATE_CLASS = "is-unavailable";

  var GEO_ENDPOINT = "https://ipapi.co/json";
  var GEO_TIMEOUT = 5000;
  var STORAGE_KEY = "saree_pdp_visitor_location_v1";
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000;

  var MONTH_LABELS = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  function readCachedLocation() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var cached = JSON.parse(raw);
      if (!cached || typeof cached.ts !== "number") return null;
      if (Date.now() - cached.ts > STORAGE_TTL) return null;

      return cached;
    } catch (error) {
      console.error("[SareeDelivery] Could not read the cached location:", error);
      return null;
    }
  }

  function writeCachedLocation(location) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ name: location.name, ts: Date.now() })
      );
    } catch (error) {
      console.error("[SareeDelivery] Could not cache the location:", error);
    }
  }

  function pickLocationName(geoData) {
    if (!geoData) return "";

    var candidates = [geoData.region, geoData.city, geoData.country_name];
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = String(candidates[i] || "").trim();
      if (candidate) return candidate;
    }
    return "";
  }

  function fetchLocationName() {
    if (typeof fetch !== "function" || typeof AbortController !== "function") {
      return Promise.resolve("");
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(function () {
      controller.abort();
    }, GEO_TIMEOUT);

    return fetch(GEO_ENDPOINT, {
      headers: { Accept: "application/json" },
      signal: controller.signal
    })
      .then(function (response) {
        clearTimeout(timeoutId);
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }
        return response.json();
      })
      .then(function (geoData) {
        var name = pickLocationName(geoData);
        if (name) writeCachedLocation({ name: name });
        return name;
      })
      .catch(function (error) {
        clearTimeout(timeoutId);
        console.error("[SareeDelivery] Location lookup failed:", error);
        return "";
      });
  }

  function getLocationName() {
    var cached = readCachedLocation();
    if (cached && cached.name) {
      return Promise.resolve(cached.name);
    }
    return fetchLocationName();
  }

  /* "Madhya Pradesh: 5-8" or "Kerala: 7" per line, first match wins. */
  function findRegionDays(rawOverrides, locationName) {
    if (!rawOverrides || !locationName) return null;

    var target = locationName.toLowerCase();
    var lines = rawOverrides.split("\n");

    for (var i = 0; i < lines.length; i += 1) {
      var parts = lines[i].split(":");
      if (parts.length < 2) continue;

      var name = parts[0].trim().toLowerCase();
      if (!name || name !== target) continue;
      var range = parts[1].split("-");
      var min = parseInt(range[0], 10);
      var max = range.length > 1 ? parseInt(range[1], 10) : min;

      if (isNaN(min)) continue;
      if (isNaN(max) || max < min) max = min;

      return { min: min, max: max };
    }

    return null;
  }

  function addDeliveryDays(startDate, days, excludeSundays) {
    var date = new Date(startDate.getTime());
    var added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (excludeSundays && date.getDay() === 0) continue;
      added += 1;
    }

    return date;
  }

  function formatDeliveryDate(date, format) {
    var day = String(date.getDate()).padStart(2, "0");
    var month = MONTH_LABELS[date.getMonth()];

    return format === "dd_mmm" ? day + " " + month : month + " " + day;
  }

  function buildDateRange(root, days) {
    var excludeSundays = root.getAttribute("data-exclude-sundays") === "true";
    var format = root.getAttribute("data-date-format") || "mmm_dd";
    var today = new Date();

    var earliest = formatDeliveryDate(
      addDeliveryDays(today, days.min, excludeSundays),
      format
    );
    var latest = formatDeliveryDate(
      addDeliveryDays(today, days.max, excludeSundays),
      format
    );

    return earliest === latest ? earliest : earliest + " - " + latest;
  }

  function resolveDays(root, locationName) {
    var min = parseInt(root.getAttribute("data-min-days"), 10);
    var max = parseInt(root.getAttribute("data-max-days"), 10);

    if (isNaN(min) || min < 0) min = 0;
    if (isNaN(max) || max < min) max = min;

    var override = findRegionDays(
      root.getAttribute("data-region-days"),
      locationName
    );

    return override || { min: min, max: max };
  }

  /* Only one of the two templates may be filled in, so fall back to the other
     rather than leaving the placeholder running forever. */
  function pickTemplate(root, locationName) {
    var withLocation = root.getAttribute("data-message") || "";
    var withoutLocation = root.getAttribute("data-fallback-message") || "";
    var template = locationName
      ? withLocation || withoutLocation
      : withoutLocation || withLocation;

    /* A template that names a location we never resolved would read
       "Get it by Aug 07 - Aug 10 to ". */
    if (!locationName && template.indexOf("[location]") !== -1) {
      return "";
    }

    return template;
  }

  function buildMessage(root, locationName) {
    var template = pickTemplate(root, locationName);
    if (!template) return "";

    var dateRange = buildDateRange(root, resolveDays(root, locationName));

    return template
      .replace(/\[dates\]/g, dateRange)
      .replace(/\[location\]/g, locationName);
  }

  function renderEstimate(root, locationName) {
    try {
      var textElement = root.querySelector(TEXT_SELECTOR);
      if (!textElement) {
        console.error("[SareeDelivery] The message element is missing.");
        return;
      }

      var message = buildMessage(root, locationName);
      if (!message) {
        root.classList.add(UNAVAILABLE_STATE_CLASS);
        return;
      }

      textElement.textContent = message;
      root.classList.add(READY_STATE_CLASS);
    } catch (error) {
      console.error("[SareeDelivery] Could not render the estimate:", error);
    }
  }

  function updateEstimates() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) return;

    getLocationName().then(function (locationName) {
      Array.prototype.forEach.call(roots, function (root) {
        renderEstimate(root, locationName);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateEstimates);
  } else {
    updateEstimates();
  }
})();
/* END - Saree PDP delivery estimate */

/* START - Saree PDP product accordions */
(function initSareeAccordions() {
  "use strict";

  var MORE_SELECTOR = "[data-saree-accordion-more]";
  var CLAMP_SELECTOR = "[data-saree-accordion-clamp]";
  var EXPANDED_STATE_CLASS = "is-expanded";

  var MORE_LABEL = "Read More";
  var LESS_LABEL = "Read Less";

  function toggleClamp(button) {
    var clamp = button.closest(CLAMP_SELECTOR);
    if (!clamp) {
      console.error("[SareeAccordion] Read more button is not inside a clamp.");
      return;
    }

    var isExpanded = clamp.classList.toggle(EXPANDED_STATE_CLASS);
    button.textContent = isExpanded ? LESS_LABEL : MORE_LABEL;
  }

  function handleDocumentClick(event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var moreButton = target.closest(MORE_SELECTOR);
      if (moreButton) {
        event.preventDefault();
        toggleClamp(moreButton);
      }
    } catch (error) {
      console.error("[SareeAccordion] Click handling failed:", error);
    }
  }

  document.addEventListener("click", handleDocumentClick);
})();
/* END - Saree PDP product accordions */



(function () {
  var BODY_CLS = 'CP_IT_PDP_18_V1';
  var ID = 'google-merchantwidget-iframe-wrapper';
  var BOTTOM = '230px';

  function apply(el) {
    if (!document.body.classList.contains(BODY_CLS)) return;
    // only write if needed, so the observer below doesn't loop forever
    if (el.style.getPropertyValue('bottom') !== BOTTOM ||
        el.style.getPropertyPriority('bottom') !== 'important') {
      el.style.setProperty('bottom', BOTTOM, 'important');
    }
  }

  function watch(el) {
    if (el.dataset.cpWatched) return;
    el.dataset.cpWatched = '1';
    apply(el);
    // widget rewrites its style attribute → put ours back
    new MutationObserver(function () { apply(el); })
      .observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  var el = document.getElementById(ID);
  if (el) watch(el);

  // widget is injected late (and can be re-injected) → wait for it
  new MutationObserver(function () {
    var w = document.getElementById(ID);
    if (w) watch(w);
  }).observe(document.body, { childList: true, subtree: true });
})();